import React from "react";

const VerifiedBadge = ({
  width = 19,
  height = 19,
  title = "This realtor is an FNP partner",
}: {
  width?: number;
  height?: number;
  title?: string;
}) => {
  return (
    <div title={title}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.05127 4.01976C7.26289 3.76455 6.40585 4.11955 6.02883 4.85749L5.57558 5.74465C5.52173 5.85006 5.436 5.93579 5.33059 5.98965L4.44343 6.4429C3.70548 6.81991 3.35049 7.67695 3.6057 8.46533L3.91252 9.41314C3.94898 9.52576 3.94898 9.64703 3.91252 9.75964L3.6057 10.7075C3.35049 11.4959 3.70548 12.3529 4.44343 12.7299L5.33059 13.1831C5.436 13.237 5.52173 13.3227 5.57558 13.4282L6.02883 14.3153C6.40585 15.0533 7.26289 15.4083 8.05127 15.1531L8.99908 14.8462C9.11169 14.8098 9.23297 14.8098 9.34558 14.8462L10.2934 15.1531C11.0818 15.4083 11.9388 15.0533 12.3159 14.3153L12.7691 13.4282C12.823 13.3227 12.9087 13.237 13.0141 13.1831L13.9013 12.7299C14.6392 12.3529 14.9942 11.4959 14.739 10.7075L14.4322 9.75964C14.3957 9.64703 14.3957 9.52576 14.4322 9.41314L14.739 8.46533C14.9942 7.67695 14.6392 6.81991 13.9013 6.4429L13.0141 5.98965C12.9087 5.93579 12.823 5.85006 12.7691 5.74465L12.3159 4.85749C11.9388 4.11955 11.0818 3.76455 10.2934 4.01976L9.34558 4.32659C9.23297 4.36304 9.11169 4.36304 8.99908 4.32659L8.05127 4.01976ZM6.2247 9.44988L7.0202 8.65433L8.61118 10.2454L11.7932 7.06338L12.5887 7.85888L8.61118 11.8363L6.2247 9.44988Z"
          fill="#b4c6e5"
        />
      </svg>
    </div>
  );
};

export default VerifiedBadge;
